import { LANDING_HREF } from 'shared/constants/links.ts'
import s from './Header.module.css'
import Logo from './white-logo.svg?react'
import LocaleSelect from '@/shared/components/LocaleSelect'

function Header() {
  return (
    <header className={s.header}>
      <a href={LANDING_HREF} className={s.link}>
        <Logo />
      </a>
      <LocaleSelect />
    </header>
  )
}

export default Header
